import { EnvironmentVariables } from "../../../../../../../Providers/EnvironmentVariablesProvider"
import { Analytic, isSpectrogramAnalytic } from "../../../Types/AnalysisDetails"
import { TraceDataConfig } from "../../../Types/Trace"

const CPPOPT_TRACE_NAMES = new Set([
    "CPPOpt", "CPPOpt_LLA", "CPPOpt_ULA",
    "CPPOpt (multi-window)", "CPPOpt_LLA (multi-window)", "CPPOpt_ULA (multi-window)"
])

const MAPOPT_TRACE_NAMES = new Set([
    "MAPOpt", "MAPOpt_LLA", "MAPOpt_ULA",
    "MAPOpt (multi-window)", "MAPOpt_LLA (multi-window)", "MAPOpt_ULA (multi-window)"
])

const PRX_TRACE_NAMES = new Set([
    "PRx"
])

const COX_TRACE_NAMES = new Set([
    "COx"
])

type AnalyticFeatureFlags = Pick<EnvironmentVariables,
    | "FEATURE_FLAG_CPPOPT"
    | "FEATURE_FLAG_MAPOPT"
    | "FEATURE_FLAG_PRX"
    | "FEATURE_FLAG_COX"
    | "FEATURE_FLAG_QEEG_DSA_ANALYTIC"
    | "FEATURE_FLAG_QEEG_ADR_ANALYTIC"
    | "FEATURE_FLAG_QEEG_SR_ANALYTIC"
>

export const isAnalyticTraceEnabled = (trace: Pick<TraceDataConfig, "name" | "onDemandAnalysis">, flags: AnalyticFeatureFlags): boolean => {
    const analytic = trace.onDemandAnalysis?.analytic

    if (!flags.FEATURE_FLAG_CPPOPT && CPPOPT_TRACE_NAMES.has(trace.name)) return false
    if (!flags.FEATURE_FLAG_MAPOPT && MAPOPT_TRACE_NAMES.has(trace.name)) return false
    if (!flags.FEATURE_FLAG_PRX && PRX_TRACE_NAMES.has(trace.name)) return false
    if (!flags.FEATURE_FLAG_COX && COX_TRACE_NAMES.has(trace.name)) return false
    if (!flags.FEATURE_FLAG_QEEG_DSA_ANALYTIC && isSpectrogramAnalytic(analytic)) return false
    if (!flags.FEATURE_FLAG_QEEG_ADR_ANALYTIC && analytic === Analytic.QEEG_ADR) return false
    if (!flags.FEATURE_FLAG_QEEG_SR_ANALYTIC && analytic === Analytic.QEEG_SR) return false
    return true
}
